module.exports = __webpack_public_path__ + "static/img/setion3_1.568f04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/setion3_1.png
// module id = 0JPx
// module chunks = 1